import { useContext } from 'react';
import { I18nContext, II18nContextProps } from './../components/render-props/I18Props';

export const useI18n = (): any => useContext<II18nContextProps>(I18nContext);
